const meetingGuestAccessStatuses = Object.freeze({
  allow: 1,
  deny: 2,
});

export { meetingGuestAccessStatuses };
